<template>
  <ion-card data-test="card-portrait-skeleton">
    <ion-card-header>
      <div class="header">
        <ion-skeleton-text :animated="true"></ion-skeleton-text>
      </div>
    </ion-card-header>
    <ion-card-content>
      <div class="title">
        <ion-skeleton-text :animated="true"></ion-skeleton-text>
      </div>
      <div class="description long">
        <ion-skeleton-text :animated="true"></ion-skeleton-text>
      </div>
      <div class="description long">
        <ion-skeleton-text :animated="true"></ion-skeleton-text>
      </div>
      <div class="description short">
        <ion-skeleton-text :animated="true"></ion-skeleton-text>
      </div>
    </ion-card-content>
  </ion-card>
</template>
<script setup lang="ts">
import {
  IonCard,
  IonCardHeader,
  IonCardContent,
  IonSkeletonText,
} from "@ionic/vue";
</script>
<style lang="scss" scoped>
@import "@/common/theme/breakpoints.scss";
ion-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 284px;
  height: 340px;
  margin: var(--spacing-0);
  background-color: var(--background-white);
  border: 2px solid var(--light-grey-border);
  border-radius: var(--spacing-24);
  box-shadow: none;
}

ion-card-header {
  padding: var(--spacing-0);
  width: 100%;
  height: fit-content;
}
ion-card-content {
  padding: var(--spacing-16);
  height: 100%;
  width: 100%;
}
.header {
  border-radius: 0px 0px var(--spacing-24) var(--spacing-24);
  height: 153px; //the height is set in the child as the header grows to fit content
  width: 100%;
  display: flex;
  align-items: center;
}

.title {
  width: 157px;
  height: 28px;
  margin-top: var(--spacing-0);
  margin-bottom: var(--spacing-12);
}
.description {
  height: 16.6px;
  margin-bottom: 6px;
  letter-spacing: 0.5px;
}
.long {
  width: 252px;
}
.short {
  width: 222px;
}
</style>
